<script>
  import { fade } from "svelte/transition";
  import { _ } from "@services/i18n";
  import { FADE_DURATION } from "../consts";
  export let inverted = false;
  export let onClick;
</script>

<style>
  .close {
    background: url("/images/close.svg") no-repeat center center;
    background-size: 100%;
    border: 0;
    cursor: pointer;
    height: 4.8rem;
    margin: 0;
    overflow: hidden;
    padding: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 4.8rem;
  }

  .inverted {
    background-image: url("/images/close-inverted.svg");
  }

  span {
    overflow: hidden;
    position: absolute;
    text-indent: 100%;
    white-space: nowrap;
  }
</style>

<button
  class="close"
  class:inverted
  data-testid="close-button"
  on:click|preventDefault|stopPropagation={onClick}
  style={$$props.style}
  transition:fade={{ duration: FADE_DURATION }}
  type="button">
  <span>{$_("components.close_button.text", { default: "Close" })}</span>
</button>
